import React from 'react';
import { useTranslation } from 'react-i18next';

const LANGS = [
  { code: 'fr', label: 'FR', full: 'Francais' },
  { code: 'de', label: 'DE', full: 'Deutsch' },
  { code: 'it', label: 'IT', full: 'Italiano' },
];

export const LanguageSelector = ({ variant = 'compact', className = '' }) => {
  const { i18n } = useTranslation();
  const current = i18n.language?.substring(0, 2) || 'fr';

  const handleChange = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem('vortekio_lang', code);
  };

  if (variant === 'full') {
    return (
      <div className={`flex flex-col gap-2 ${className}`} data-testid="language-selector-full">
        {LANGS.map(({ code, full }) => (
          <button
            key={code}
            onClick={() => handleChange(code)}
            data-testid={`lang-btn-${code}`}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 text-left ${
              current === code
                ? 'bg-blue-600 text-white shadow-md'
                : 'bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700'
            }`}
          >
            {full}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid="language-selector">
      {LANGS.map(({ code, label }) => (
        <button
          key={code}
          onClick={() => handleChange(code)}
          data-testid={`lang-btn-${code}`}
          className={`px-2 py-1 rounded text-xs font-bold transition-all duration-200 ${
            current === code
              ? 'bg-white/20 text-white shadow-sm'
              : 'text-white/50 hover:text-white/80 hover:bg-white/10'
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export const LanguageSelectorDark = ({ className = '' }) => {
  const { i18n } = useTranslation();
  const current = i18n.language?.substring(0, 2) || 'fr';

  const handleChange = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem('vortekio_lang', code);
  };

  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid="language-selector-dark">
      {LANGS.map(({ code, label }) => (
        <button
          key={code}
          onClick={() => handleChange(code)}
          data-testid={`lang-btn-dark-${code}`}
          className={`px-2.5 py-1 rounded-md text-xs font-bold transition-all duration-200 ${
            current === code
              ? 'bg-slate-700 text-white ring-1 ring-slate-500'
              : 'text-slate-500 hover:text-slate-300 hover:bg-slate-800'
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
};
